<template>
  <div class="calculator-wrapper">
    <div class="calculator">
      <CalculatorHeading :step="step"></CalculatorHeading>
      <SelectMultipleInput
        :question="$t('other.question')"
        :image="require('@/assets/sauna.jpeg')"
        :selections="selections"
        :clicked-callback="onSelect"
        :next="next"
      ></SelectMultipleInput>
      <a
        @click="$router.push(getPrevStepUrl(step, $i18n.locale))"
        class="back-btn"
        >{{ $t("back") }}</a
      >
    </div>
  </div>
</template>

<script>
  import {mapMutations} from "vuex";
  import CalculatorHeading from "../../components/CalculatorHeading";
  import {getStepIndex} from "@/utils/steps.js";
  import {getPrevStepUrl, goToNextStep, redirectToUnselectedStepIfAny} from "../../utils/steps";
  import SelectMultipleInput from "../../components/SelectMultipleInput";

  export default {
  name: "Other",
  components: { SelectMultipleInput, CalculatorHeading },
  data() {
    return {
      step: getStepIndex("other"),
      getPrevStepUrl: getPrevStepUrl,
      selections: [
        {
          name: this.$t("other.sauna"),
          selected: this.$store.state.data.sauna,
          update: value => this.updateSauna(value)
        },
        {
          name: this.$t("other.roof-windows"),
          selected: this.$store.state.data.roofWindows,
          update: value => this.updateRoofWindows(value)
        },
        {
          name: this.$t("other.irrigation"),
          selected: this.$store.state.data.irrigation,
          update: value => this.updateIrrigation(value)
        },
        {
          name: this.$t("other.electric-vehicle"),
          selected: this.$store.state.data.electricVehicle,
          update: value => this.updateElectricVehicle(value)
        },
        {
          name: this.$t("other.solar-system"),
          selected: this.$store.state.data.solar,
          update: value => this.updateSolar(value)
        },
        {
          name: this.$t("other.heat-pump-control"),
          selected: this.$store.state.data.heatPump,
          update: value => this.updateHeatPump(value)
        }
      ]
    };
  },
  mounted() {
    redirectToUnselectedStepIfAny(
      this.step,
      this.$store.state.data,
      this.$router,
      this.$i18n.locale
    );
  },
  methods: {
    ...mapMutations([
      "updateSauna",
      "updateIrrigation",
      "updateRoofWindows",
      "updateElectricVehicle",
      "updateSolar",
      "updateHeatPump"
    ]),
    onSelect(selection) {
      selection.update(!selection.selected);
      selection.selected = !selection.selected;
    },
    next() {
      goToNextStep(this.step, this.$i18n.locale, this.$router);
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../common/_variables.scss";
h4 {
  color: $color-primary;
}
.back-btn {
  margin-top: 60px;
}
</style>
